import { render, staticRenderFns } from "./FormLoader.vue?vue&type=template&id=15330ee5"
import script from "./FormLoader.vue?vue&type=script&lang=js"
export * from "./FormLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports